export default {
  saveLastVisitedRoute({ commit }, from) {
    commit('SET_LAST_VISITED_ROUTE', from);
  },
};
